import gql from 'graphql-tag';

export const updateLeaderboard = gql`
  mutation updateLeaderboard($input: InputUpdateLeaderboardFields) {
    updateLeaderboard(input: $input) {
      id
      name
      periodFrom
      periodTo
      active
    }
  }
`;

export const activeLeaderboard = gql`
  mutation activeLeaderboard($input: InputUpdateLeaderboard) {
    activeLeaderboard(input: $input) {
      id
      name
      periodFrom
      periodTo
      active
    }
  }
`;
